import React from 'react';
import { ListingRoute } from '../../models';
import DefaultRouter, {
  profitableGoingConcernRoutes,
} from './default-router/router';
import { Navigate } from 'react-router-dom';
import ListingDetailsPreview from '../../common-pages/ListingDetailsPreview';

export default [
  {
    path: 'preview-mode',
    element: ListingDetailsPreview,
  },
  {
    path: 'default',
    element: DefaultRouter,
    routes: profitableGoingConcernRoutes,
  },
  { index: true, element: <Navigate to="default" replace /> },
] as Array<ListingRoute>;
